'use client';

import { DiningWorkspace } from '@/app/dining/Workspace';
import { DiningDirectoryView } from '@/app/dining/DiningDirectoryView';
import { diningRepeatedCategoryFixtureModel } from '@/app/dining/DiningDirectory.fixtures';
import { EventsAuditFixture } from '@/app/events/auditFixture';
import { EventsWorkspace } from '@/app/events/Workspace';

const diningFixtureActions = {
  onHallChange: () => undefined,
  onMealChange: () => undefined,
  onDateChange: () => undefined,
  onSearchChange: () => undefined,
  onVegetarianChange: () => undefined,
  onClearFilters: () => undefined,
  onRetry: () => undefined,
  onSelectItem: () => undefined,
  onCloseItem: () => undefined,
};

export function CampusEmbeddedWorkspace({ mode, auditFixture }: { mode: 'dining' | 'events'; auditFixture?: string }) {
  if (auditFixture === 'campus-populated') {
    return (
      <div data-audit-ready={`campus-${mode}-populated`}>
        {mode === 'dining'
          ? <DiningDirectoryView embedded model={diningRepeatedCategoryFixtureModel} actions={diningFixtureActions} />
          : <EventsAuditFixture state="populated" embedded />}
      </div>
    );
  }
  return mode === 'dining' ? <DiningWorkspace embedded /> : <EventsWorkspace embedded />;
}
